var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.4,
    height: 16.4,
    viewBox: "0 0 16.4 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_sistema",
    "data-name": "icona sistema",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_925",
    "data-name": "Tracciato 925",
    d: "M38.608,14.605a.356.356,0,0,1,0-.711.568.568,0,0,0,.567-.567,1.145,1.145,0,0,1,1.954-.809.58.58,0,0,0,.8,0l1.11-1.11a.567.567,0,0,0,0-.8,1.144,1.144,0,0,1,.809-1.953h0a.567.567,0,0,0,.566-.567V6.518a.567.567,0,0,0-.566-.567h0A1.144,1.144,0,0,1,43.039,4a.567.567,0,0,0,0-.8l-1.11-1.11a.581.581,0,0,0-.8,0,1.144,1.144,0,0,1-1.953-.809.568.568,0,0,0-.567-.567H37.039a.567.567,0,0,0-.566.566,1.144,1.144,0,0,1-1.954.809.568.568,0,0,0-.8,0L32.608,3.2a.568.568,0,0,0,0,.8A1.144,1.144,0,0,1,31.8,5.951h0a.568.568,0,0,0-.566.567.356.356,0,0,1-.356.355h0a.356.356,0,0,1-.355-.356A1.281,1.281,0,0,1,31.8,5.24h0A.433.433,0,0,0,32.1,4.5a1.279,1.279,0,0,1,0-1.807l1.11-1.11a1.28,1.28,0,0,1,1.807,0,.433.433,0,0,0,.74-.306A1.275,1.275,0,0,1,37.038,0h1.57a1.279,1.279,0,0,1,1.278,1.278.433.433,0,0,0,.74.306,1.278,1.278,0,0,1,1.807,0l1.109,1.11a1.279,1.279,0,0,1,0,1.807.433.433,0,0,0,.306.74h0a1.278,1.278,0,0,1,1.277,1.278V8.087a1.278,1.278,0,0,1-1.278,1.278h0a.433.433,0,0,0-.306.739,1.278,1.278,0,0,1,0,1.807l-1.109,1.109a1.277,1.277,0,0,1-1.807,0,.434.434,0,0,0-.739.307,1.28,1.28,0,0,1-1.278,1.278Z",
    transform: "translate(-29.126)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_926",
    "data-name": "Tracciato 926",
    d: "M131.172,97.547a.356.356,0,0,1-.145-.681,2.408,2.408,0,1,0-3.182-3.167.356.356,0,0,1-.651-.287,3.119,3.119,0,1,1,4.122,4.1A.349.349,0,0,1,131.172,97.547Z",
    transform: "translate(-121.352 -87.363)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_927",
    "data-name": "Tracciato 927",
    d: "M5.033,159.745H4.083a.913.913,0,0,1-.913-.913.122.122,0,0,0-.207-.086.914.914,0,0,1-1.292,0L1,158.074a.913.913,0,0,1,0-1.292.122.122,0,0,0-.076-.207H.913A.915.915,0,0,1,0,155.662v-.95a.915.915,0,0,1,.913-.914.109.109,0,0,0,.113-.075A.11.11,0,0,0,1,153.591.915.915,0,0,1,1,152.3l.672-.672a.915.915,0,0,1,1.291,0,.109.109,0,0,0,.133.026.11.11,0,0,0,.075-.112.913.913,0,0,1,.913-.913h.95a.915.915,0,0,1,.913.913.109.109,0,0,0,.075.112.111.111,0,0,0,.132-.027.913.913,0,0,1,1.292,0l.671.671a.914.914,0,0,1,0,1.292.122.122,0,0,0,.086.208.913.913,0,0,1,.913.914v.949a.913.913,0,0,1-.914.913.122.122,0,0,0-.086.208.913.913,0,0,1,0,1.292l-.671.671a.908.908,0,0,1-.645.268h0a.907.907,0,0,1-.646-.268.122.122,0,0,0-.207.086A.915.915,0,0,1,5.033,159.745ZM3.04,158a.862.862,0,0,1,.328.065.82.82,0,0,1,.513.769.2.2,0,0,0,.2.2h.949a.2.2,0,0,0,.2-.2.833.833,0,0,1,1.421-.588.2.2,0,0,0,.143.059h0a.2.2,0,0,0,.143-.059l.671-.671a.2.2,0,0,0,0-.286.833.833,0,0,1,.589-1.422.2.2,0,0,0,.2-.2v-.949a.2.2,0,0,0-.2-.2.833.833,0,0,1-.589-1.422.2.2,0,0,0,0-.286l-.671-.671a.2.2,0,0,0-.286,0,.833.833,0,0,1-1.421-.589.2.2,0,0,0-.2-.2H4.083a.2.2,0,0,0-.143.059.2.2,0,0,0-.059.143.833.833,0,0,1-1.422.589.2.2,0,0,0-.286,0L1.5,152.8a.2.2,0,0,0,0,.286.833.833,0,0,1-.589,1.422.2.2,0,0,0-.2.2v.949a.2.2,0,0,0,.194.2H.913a.833.833,0,0,1,.589,1.422.2.2,0,0,0,0,.286l.671.671a.2.2,0,0,0,.286,0A.806.806,0,0,1,3.04,158Z",
    transform: "translate(0 -143.745)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_928",
    "data-name": "Tracciato 928",
    d: "M57.4,210.055a2.027,2.027,0,0,1-.778-3.9h0a2.027,2.027,0,1,1,.778,3.9Zm0-3.343a1.31,1.31,0,0,0-.5.1h0a1.308,1.308,0,1,0,.5-.1Zm-.638-.228h0Z",
    transform: "translate(-52.836 -196.585)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.60ca619ec17e876f932e9e0f32cedebc.svg";
export { ForwardRef as ReactComponent };